export const VILLA_HOST_SUPPORT_PHONE_NUMBER = "+982192000123";
